import VueI18n from "vue-i18n";
import { createI18n } from "../i18n";
import NewsDetailCruiseList from "./NewsDetailCruiseList.vue";

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("newsDetailCruiseList");
  if (!el) return;

  window.mainVue.use(VueI18n);

  var filter = {};
  try {
    if (typeof window.transferState !== "undefined") {
      filter = window.transferState.get("cruise_filter") || {};
    }
  } catch (e) { /* ignore */ }
  if (!Object.prototype.hasOwnProperty.call(filter, "date_from")) {
    filter.date_from = Math.floor(Date.now() / 1000);
  }

  new window.mainVue({
    i18n: createI18n(),
    render: function (h) {
      return h(NewsDetailCruiseList, { props: { filter: filter } });
    },
  }).$mount(el);
});
